import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { LoadingScreen } from "@/components/ProtectedRoute";

export default function AuthCallback() {
  const { setUser, API } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      setUser(false);
      navigate("/login", { replace: true });
      return;
    }
    const inviteToken = location.pathname.startsWith("/activate/")
      ? decodeURIComponent(location.pathname.slice("/activate/".length))
      : null;
    axios
      .post(
        `${API}/auth/google/session`,
        { session_id: sessionId, invite_token: inviteToken },
        { withCredentials: true }
      )
      .then(({ data }) => {
        setUser(data);
        navigate(data.is_platform_admin ? "/admin/overview" : data.onboarded ? "/dashboard" : "/onboarding", {
          replace: true,
          state: { user: data },
        });
      })
      .catch((err) => {
        setUser(false);
        navigate("/login", {
          replace: true,
          state: { authError: formatApiErrorDetail(err.response?.data?.detail) },
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingScreen label="Signing you in…" />;
}
